import { createAsyncActionType } from './index';

export const GET_NAVBAR = createAsyncActionType('navbar', 'GET_NAVBAR');
